import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BehaviorSubject, interval, Observable, Subject} from 'rxjs';
import {SocketMessagesService, TIncident} from '../socket/socket.service';
import {filter, map, switchMap, takeUntil, tap} from 'rxjs/operators';


@Component({
    selector: 'sam4-reconnection-dialog',
    templateUrl: './reconnection-dialog.component.html',
    styleUrls: ['./reconnection-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ReconnectionDialogComponent implements OnInit, OnDestroy {
    private destroy$$: Subject<void> = new Subject<void>();
    public canRetry$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public retryButtonDisabled$!: Observable<boolean>;
    public reconnectionMessage$!: Observable<string>;

    constructor(
        private modal: NgbActiveModal,
        private messages: SocketMessagesService,
    ) {
    }

    ngOnInit(): void {
        this.retryButtonDisabled$ = this.canRetry$$.asObservable().pipe(
            takeUntil(this.destroy$$.asObservable()),
            map(_ => !_)
        );
        this.reconnectionMessage$ = this.messages.reconnectionInterval$.pipe(
            takeUntil(this.destroy$$.asObservable()),
            switchMap(intervalPeriod => {
                return interval(1000).pipe(
                    map(i => intervalPeriod - i - 1),
                );
            }),
            map((value) => {
                let result = 'Reconnecting';
                if (value) {
                    result += ' in ' + value + 's';
                    this.canRetry$$.next(true);
                } else {
                    result += '...';
                    this.canRetry$$.next(false);
                }
                return result;
            }),
        );
        this.messages.incidents$.pipe(
            takeUntil(this.destroy$$.asObservable()),
            filter((i) => (['connected', 're-connected', 'no-connection'] as TIncident[]).includes(i.type)),
            tap(() => this.close())
        ).subscribe();

    }

    ngOnDestroy(): void {
        this.destroy$$.next(true as unknown as void);
    }

    close(): void {
        this.modal.close();
    }

    retry(): void {
        this.messages.forceConnect();
    }
}
